import { fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_PROGRAM_PICKLIST + actions.FULFILLED:
            {
                return state.set('programs', fromJS(action.payload));
            }
        case actions.GET_TRAININGTYPES_PICKLIST + actions.FULFILLED:
            {
                return state.set('trainingTypes', fromJS(action.payload));
            }

        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        programs: [],
        trainingTypes: []
    });
};